export const ACTION_RESET = 'FETCH_SBEPROGRAMME_RESET';
export const ACTION_REQUEST = 'FETCH_SBEPROGRAMME_REQUEST';
export const ACTION_SUCCESS = 'FETCH_SBEPROGRAMME_SUCCESS';
export const ACTION_ERROR = 'FETCH_SBEPROGRAMME_ERROR';
